<template>
    <div class="questions row align-items-center h-100">
        <div class="col align-self-center text-center">
            <transition name="slide-left" mode="out-in">
                <template v-if="loadingData">
                    <template v-if="getComplete">
                        <div class="getdata" v-if="$root.query.video">
                            <h1 class="text-center pb-3" style="font-size: 24px;">
                                Curious about Speech Blubs?
                                Watch Harper have a go!
                            </h1>
                            <video loop playsinline src="https://cdn.speechblubs.com/FB_ADD.mp4" ref="video"
                                   poster="https://cdn.speechblubs.com/2020/08/Thumbnail_txt-1.png"
                                   style="width: 100%"></video>
                            <transition name="fade" mode="out-in">
                                <div v-if="loader.data && loader.timeout" class="pt-3">
                                    <button @click="getReport()" class="btn btn-lg btn-purple gtm-screener-get-report" style="width: 100%">
                                        Get report
                                    </button>
                                </div>
                                <div class="pt-3" v-else>
                                    <div class="d-flex justify-content-center">
                                        <div class="loader"></div>
                                    </div>

                                    <h4 class="text-center pt-2">Crunching your report…</h4>
                                </div>
                            </transition>
                        </div>
                        <div v-else>
                            <h4 class="text-center pt-2">Crunching your report…</h4>
                        </div>
                    </template>
                    <template v-else>
                        <div class="loading">
                            <img src="../assets/img/loading.svg" height="80px">
                            <h4>Personalizing questions...</h4>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="group" v-for="(group, i) in questions.groups" :key="group._id"
                         v-if="$route.params.group === group.title.toLowerCase()">
                        <transition-group name="slide-left" mode="out-in">
                            <img v-if="group.titleImage" :key="group._id + 'titleImage'" :src="group.titleImage.data"
                                 height="80px">
                            <p class="group-title" v-if="group.title !== 'Basics'" :key="group._id + 'title'">
                                {{group.title}}</p>
                        </transition-group>

                        <transition name="slide-left" mode="out-in">
                            <div class="question" v-for="(question, j) in group.questions" :key="question._id"
                                 v-if="$route.params.question === question._id">
                                <img v-if="question.titleImage" :src="question.titleImage" height="80px">

                                <div class="d-flex align-items-center justify-content-center text">
                                    <div>
                                        <h4>{{question.text | processText(details)}}</h4>
                                        <p v-if="question.description">{{question.description |
                                            processText(details)}}</p>
                                    </div>
                                </div>

                                <div class="answer input" v-if="question.type === 'text'">
                                    <form @submit="nextQuestion(i, j, $event)">
                                        <div class="form-group">
                                            <input type="text" class="form-control form-control-lg" :name="question._id"
                                                   v-model="name" placeholder="Your child's name" required>
                                        </div>
                                        <button type="submit" class="btn btn-purple btn-lg">Continue</button>
                                    </form>
                                </div>
                                <div class="answer input" v-else-if="question.type === 'date'">
                                    <form @submit="nextQuestion(i, j, $event)">
                                        <div class="form-group">
                                            <datepicker :format="'yyyy-MM-dd'" :disabled-dates="disabledDates"
                                                        :initial-view="'year'" :input-class="'form-control-lg'"
                                                        :bootstrap-styling="true" :required="true"
                                                        :placeholder="'Birth date'" ref="datepicker" @opened="scrollTo"
                                                        v-model="birthDate"></datepicker>
                                        </div>
                                        <button type="submit" class="btn btn-purple btn-lg">Continue</button>
                                    </form>
                                </div>
                                <div class="answer input" v-else-if="question.type === 'diagnose'">
                                    <form @submit="nextQuestion(i, j, $event)">
                                      <div class="diagnosis">
                                          <div class="diagnosis__search">
                                              <div class="diagnosis__search__icon">
                                                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3602 11.9846C13.5958 11.2202 12.3621 11.2146 11.5927 11.984C10.8287 12.7481 10.8221 13.9803 11.5933 14.7515L15.4659 18.6241C16.2303 19.3885 17.464 19.3941 18.2334 18.6247C18.9975 17.8606 19.004 16.6284 18.2328 15.8572L14.3602 11.9846Z" fill="#787878"/>
                                                      <path d="M8.26087 14.5217C11.7187 14.5217 14.5217 11.7187 14.5217 8.26087C14.5217 4.80309 11.7187 2 8.26087 2C4.80309 2 2 4.80309 2 8.26087C2 11.7187 4.80309 14.5217 8.26087 14.5217Z" stroke="#787878" stroke-width="4"/>
                                                  </svg>
                                              </div>
                                              <input type="text" placeholder="Search..." v-model="diagnoses.search">
                                          </div>
                                          <div class="diagnosis__box">
                                              <template v-for="(diagnosis, di) of diagnoses.data">
                                                  <label class="diagnosis__select d-flex align-items-center" :key="di" v-if="diagnosis.title.toLowerCase().includes(diagnoses.search.toLowerCase()) || diagnoses.selected.includes(diagnosis.title)">
                                                      <input type="checkbox" name="diagnosis" v-model="diagnoses.selected" :value="diagnosis.title">
                                                      <div>
                                                          <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.398 0.615506C15.2198 -0.20624 16.5575 -0.205569 17.383 0.619931L17.5014 0.748258C18.2118 1.583 18.1693 2.82299 17.3874 3.60489L8.41036 12.582C8.2871 12.7052 8.15223 12.81 8.00922 12.8962L8.09486 12.8016C7.26936 13.6271 5.93694 13.6331 5.10575 12.8019L0.621081 8.31723C-0.162993 7.53315 -0.207274 6.29133 0.502955 5.45642L0.621367 5.32812C1.44687 4.50262 2.77929 4.49663 3.61048 5.32782L6.648 8.36499L14.398 0.615506Z" fill="currentColor"/>
                                                          </svg>
                                                      </div>
                                                      <span>
                                                      {{diagnosis.title}}
                                                    </span>
                                                  </label>
                                              </template>
                                          </div>
                                      </div>

                                        <div class="diagnosis__btn">
                                            <button class="btn btn-purple btn-lg">
                                                <span v-if="diagnoses.selected.length">
                                                    Continue
                                                </span>
                                                <span v-else>
                                                    No diagnoses
                                                </span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div class="answer buttons" v-else>
                                      <span v-for="answer in question.answers" :key="answer.value"
                                            @click="saveAnswer(i, j, answer); nextQuestion(i, j)"
                                            :class="question.answer && question.answer.value === answer.value ? 'selected' : false">
                                        {{answer.label}}
                                      </span>
                                </div>
                            </div>
                        </transition>
                    </div>
                </template>
            </transition>
        </div>
        <screener-popup :type="popup.type" :open="popup.open" @next="popup.open = false"></screener-popup>
    </div>
</template>

<script>
    import uuidv4 from 'uuid/v4'

    import Datepicker from 'vuejs-datepicker'

    import RestClient from '../services/rest-client'
    import ScreenerPopup from "./ScreenerPopup";

    export default {
        name: 'ScreenerQuestions',
        components: {
            ScreenerPopup,
            Datepicker
        },
        created () {
            // if from email don't send event
        },
        data () {
            return {
                disabledDates: {
                    from: new Date()
                },

                name: null,
                birthDate: null,
                gender: null,
                evaluation: null,

                loadingData: false,
                getComplete: false,
                email: null,
                diagnoses: {
                    data: [],
                    search: '',
                    selected: [],
                },
                loader: {
                    data: false,
                    timeout: false,
                },
                section: null,
                popup: {
                    open: false,
                    type: true,
                },
                questions: {
                    groups: [{
                        title: 'Basics',
                        questions: [
                            {
                                _id: 'name',
                                text: 'Enter your child’s name',
                                description: 'It’ll help us personalize this screener',
                                type: 'text',
                                titleImage: require('../assets/img/children.svg')
                            },
                            {
                                _id: 'gender',
                                text: 'Is {{name}} a girl or a boy?',
                                answers: [{
                                    'label': 'Boy',
                                    'value': 'male'
                                }, {
                                    'label': 'Girl',
                                    'value': 'female'
                                }],
                                titleImage: require('../assets/img/children.svg')
                            },
                            {
                                _id: 'birth-date',
                                text: 'When was {{gender-he}} born?',
                                description: 'We need your child’s birthdate, so we can ask you relevant questions according to {{gender-his}} age group.',
                                type: 'date',
                                titleImage: require('../assets/img/cake.svg')
                            },
                            {
                                _id: 'evaluation',
                                text: 'Has {{name}} ever been evaluated by a speech therapist?',
                                answers: [{
                                    'label': 'Yes',
                                    'value': 'yes'
                                }, {
                                    'label': 'No',
                                    'value': 'no'
                                }, {
                                    'label': 'Can\'t tell',
                                    'value': 'skip'
                                }],
                                titleImage: require('../assets/img/board.svg')
                            },
                            {
                                _id: 'diagnoses',
                                text: 'Has {{name}} been diagnosed with any of the following conditions?',
                                type: 'diagnose',
                                titleImage: require('../assets/img/board.svg')
                            },
                        ]
                    }]
                }
            }
        },
        computed: {
            details: function () {
                return {
                    firstName: this.name,
                    gender: this.gender,
                    birthDate: this.birthDate ? this.birthDate.getTime() / 1000 : null
                }
            },
            hasEmail: function () {
                return Object.prototype.hasOwnProperty.call(this.$parent, 'email') && this.$parent.email && this.$parent.email.length !== 0
            },
            source: function () {
                return Object.prototype.hasOwnProperty.call(this.$parent, 'source') && this.$parent.source && this.$parent.source.length !== 0 ? this.$parent.source : undefined
            }
        },
        methods: {
            getReport () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'gtm-screener-report-get'
                });
                this.$router.push({ name: 'report' });

            },
            getAge (dateString) {
                const today = new Date();
                const birthDate = new Date(dateString);
                let age = today.getFullYear() - birthDate.getFullYear();
                const m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;
            },
            nextQuestion: function (groupIndex, questionIndex, event) {
                if (event) event.preventDefault();

                if (this.questions.groups[groupIndex].title.toLowerCase() !== 'basics') {
                    const id = this.questions.groups[groupIndex].questions[questionIndex]._id;
                    let value = this.questions.groups[groupIndex].questions[questionIndex].answer ? this.questions.groups[groupIndex].questions[questionIndex].answer.value : null;

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'gtm-screener-answers',
                        'id': id,
                        'value': value,
                    });
                } else {
                    switch (this.questions.groups[groupIndex].questions[questionIndex]._id) {
                    case 'name':
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'gtm-screener-enter-childs-name'
                        });
                        break;
                    case 'gender':
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'gtm-screener-enter-childs-gender',
                            'value': this.gender
                        });
                        break;
                    case 'birth-date':
                        const age = this.getAge(this.birthDate);
                        if(age < 15){
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'gtm-screener-enter-childs-age',
                                'value': `${age}-${age+1}`
                            });
                        }
                        break;
                    case 'evaluation':
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'gtm-screener-enter-evaluation',
                            'value': this.evaluation
                        });
                        break;
                    case 'diagnoses':
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'gtm-screener-enter-diagnoses',
                            'value': this.diagnoses.selected.join(',')
                        });
                        break;
                    }
                }

                if (questionIndex === 0) {
                    localStorage.setItem('screener.startedAt', new Date().getTime() / 1000)
                }

                const nextGroupIndex = groupIndex + 1;
                const nextQuestionIndex = questionIndex + 1
                let group = null
                let question = null

                if (this.questions.groups[groupIndex].questions[nextQuestionIndex]) {
                    group = this.questions.groups[groupIndex].title.toLowerCase()
                    question = this.questions.groups[groupIndex].questions[nextQuestionIndex]._id
                } else if (this.questions.groups[nextGroupIndex]) {
                    if (this.questions.groups[nextGroupIndex].questions[0]) {
                        group = this.questions.groups[nextGroupIndex].title.toLowerCase()
                        question = this.questions.groups[nextGroupIndex].questions[0]._id
                    }
                } else {
                    if (this.getComplete) {
                        this.postQuestions()
                    } else {
                        this.getQuestions()
                    }
                }
                if(this.section !== group){
                    this.popup.type = group;
                    this.popup.open = true;
                }
                this.section = group;
                if (group && question) {
                    if(question === 'evaluation'){
                        this.getDiagnoses()
                    }
                    if(question === 'diagnoses'){
                        if(this.evaluation !== 'yes'){
                            this.getQuestions();
                        }
                    }
                    this.$router.push({
                        name: 'questions',
                        params: {
                            group: group,
                            question: question
                        }
                    })
                }
            },
            saveAnswer (group, question, answer) {
                if (this.questions.groups[group].questions[question]._id === 'gender') {
                    this.gender = answer.value
                }
                else if (this.questions.groups[group].questions[question]._id === 'evaluation') {
                    this.evaluation = answer.value;
                }
                else {
                    this.questions.groups[group].questions[question].answer = answer
                }
            },
            getDiagnoses: function(){
                const restClient = new RestClient()
                restClient
                    .get(`/v2/screener?birthDate=${this.birthDate.getTime() / 1000}&gender=${this.gender}`)
                    .then((response) => {
                        this.diagnoses.data = response.data.diagnoses;
                    })
            },
            getQuestions: function () {
                if (this.name && this.gender && this.birthDate) {
                    localStorage.setItem('childDetails', JSON.stringify(this.details))

                    const restClient = new RestClient()

                    this.loadingData = true;

                    restClient
                        .get(`/v2/screener?birthDate=${this.birthDate.getTime() / 1000}&gender=${this.gender}`)
                        .then((response) => {
                            this.loadingData = false;
                            this.getComplete = true;

                            if (response.data.groups.length > 0) {
                                Array.prototype.push.apply(this.questions.groups, response.data.groups);
                                if(this.$root.query.tools){
                                    this.questions.groups.push({
                                        title: 'Learning tools',
                                        questions: [
                                            {
                                                _id: 'learningtools',
                                                text: 'To help your kid, would you use a speech development app approved by speech therapists if it was free to try out?',
                                                answers: [{
                                                    'label': 'Yes',
                                                    'value': 'yes'
                                                }, {
                                                    'label': 'No',
                                                    'value': 'no'
                                                }, {
                                                    'label': 'Can\'t tell',
                                                    'value': 'skip'
                                                }],
                                                titleImage: require('../assets/img/learning.svg')
                                            },
                                        ]
                                    });
                                }
                                this.$router.push({
                                    path: `/screener/${this.questions.groups[1].title.toLowerCase()}/${this.questions.groups[1].questions[0]._id}`
                                })
                            } else {
                                this.$router.push({
                                    name: 'to-young'
                                })
                            }
                        })
                } else {
                    alert('Missing data!')
                }
            },
            postQuestions: function () {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    'event': 'gtm-screener-finished'
                })

                const restClient = new RestClient()

                this.loadingData = true

                this.questions['firstName'] = this.name
                this.questions['birthDate'] = this.birthDate.getTime() / 1000
                this.questions.groups.splice(0, 1);
                if(this.$root.query.tools){
                    this.questions.groups.splice(-1, 1);
                }

                let userIdentifier = window.localStorage.getItem('screener.identifier')

                if (!userIdentifier) {
                    userIdentifier = uuidv4()
                    userIdentifier += `-${navigator.userAgent.replace(/ /g, '-')}`
                    window.localStorage.setItem('screener.identifier', userIdentifier)
                }

                if (this.hasEmail) {
                    this.questions.email = this.$parent.email
                }

                this.questions.device = userIdentifier

                this.questions.startedAt = window.localStorage.getItem('screener.startedAt')
                this.questions.finishedAt = new Date().getTime() / 1000
                if(this.$root.query.video){
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'gtm-screener-report-loader'
                    });
                    setTimeout(() => {
                        window.dataLayer = window.dataLayer || []
                        window.dataLayer.push({
                            'event': 'gtm-screener-video'
                        });
                        let eventsfired = {
                            "25%": false,
                            "50%": false,
                            "75%": false,
                        };
                        this.$refs.video.play();
                        this.$refs.video.ontimeupdate = () => {
                            let percentage = this.$refs.video.currentTime / this.$refs.video.duration;
                            if (!eventsfired["25%"] && percentage > 0.25) {
                                window.dataLayer = window.dataLayer || []
                                window.dataLayer.push({
                                    'event': 'gtm-screener-video-25'
                                });
                                eventsfired["25%"] = true;
                            }
                            if (!eventsfired["50%"] && percentage > 0.50) {
                                window.dataLayer = window.dataLayer || []
                                window.dataLayer.push({
                                    'event': 'gtm-screener-video-50'
                                });
                                eventsfired["50%"] = true;
                            }
                            if (!eventsfired["75%"] && percentage > 0.75) {
                                window.dataLayer = window.dataLayer || []
                                window.dataLayer.push({
                                    'event': 'gtm-screener-video-75'
                                });
                                eventsfired["75%"] = true;
                            }
                        };
                    }, 250);

                    restClient
                        .post('/v2/screener', this.questions)
                        .then((response) => {
                            localStorage.setItem('report', JSON.stringify(response.data))
                            this.loader.data = true;
                        });
                    setTimeout(() => {
                        this.loader.timeout = true;
                        setTimeout(() => {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'gtm-screener-video-finish'
                            });
                        }, 0)
                    }, 30000)
                }
                else{
                    restClient
                        .post('/v2/screener', this.questions)
                        .then((response) => {
                            localStorage.setItem('report', JSON.stringify(response.data))
                            this.loader.data = true;
                            this.getReport();
                        });

                }

            },
            scrollTo: function () {
                const position = this.$refs.datepicker[0].$el.getBoundingClientRect().top

                setTimeout(() => {
                    window.scrollTo(0, position - 10);
                }, 200)
            }
        },
        mounted () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'gtm-screener-start'
            });
        }
    }
</script>

<style lang="less" scoped>
    @keyframes loader {
        from {
            width: 30px;
        }
        to {
            width: 100%;
        }
    }

    .questions {
        .col {
            margin: auto;
        }

        .group {
            padding: 40px 0;
        }
        .getdata {
            width: 100%;
            max-width: 400px;
            margin: 0 auto;
            padding: 0 15px;
            h1 {
                color: #1e1e1e;
                font-weight: bold;
                font-size: 32px;
                line-height: 48px;
                @media (max-width: 991px) {
                    font-size: 18px;
                    line-height: 22px;
                }
            }
            h4 {
                font-size: 16px;
                line-height: 24px;
                color: #5a5a5a;
            }
        }
        .loader {
            width: 100%;
            max-width: 300px;
            height: 30px;
            border: solid 3px #5ad2aa;
            border-radius: 30px;
            position: relative;
            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 30px;
                border-radius: 30px;
                background: #5ad2aa;
                animation: loader 30s linear forwards;
            }
        }

        .group-title {
            color: #5dd1aa;
            font-size: 18px;
            margin: 30px 0 0;
            text-transform: uppercase;
        }

        .question {
            .text {
                min-height: 160px;

                h4 {
                    font-size: 20px;
                    font-weight: 700;
                    margin: 10px 0 10px;
                }

                p {
                    margin: 20px 0 10px;
                }
            }

            .answer {
                &.input {
                    .form-control, .btn, .vdp-datepicker {
                        margin: 0 auto;
                        max-width: 300px;
                        width: 100%;
                    }
                }

                &.buttons {
                    span {
                        color: #3c32a0;
                        cursor: pointer;
                    }

                    span:nth-child(-n+2) {
                        border: 2px #3c32a0 solid;
                        border-radius: 50%;
                        display: inline-block;
                        height: 90px;
                        line-height: 86px;
                        margin: 10px;
                        width: 90px;

                        #app:not(.touch) &:hover, &:focus, &:active, &.selected {
                            background: #3c32a0;
                            color: #fff;
                            transition: background 0.2s, color 0.2s;
                        }
                    }

                    span:nth-child(3) {
                        display: block;
                        margin: 30px 0 0;
                    }
                }
            }
        }

        .loading {
            h4 {
                margin: 30px 0 0;
            }
        }
    }
</style>
